import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-mimics-views-menu',
    templateUrl: './mimics-views-menu.component.html',
    styleUrls: ['./mimics-views-menu.component.css'],
    standalone: false
})
export class MimicsViewsMenuComponent {
    @Input() mimic: any;
    @Input() selectedGroup;

    @Output() groupSelected = new EventEmitter();
    @Output() toggleDropdown = new EventEmitter();
    @Output() onNavigateTo = new EventEmitter();

    constructor(private router: Router) {}

    isgroupActive(groupName: string) {
        return this.selectedGroup && this.selectedGroup.name === groupName;
    }

    groupSelectedEmit(mimicGroup) {
        this.groupSelected.emit(mimicGroup);
    }

    toggleDropdownEmit() {
        this.toggleDropdown.emit('view');
    }

    onNavigateToEmit(mimic) {
        this.onNavigateTo.emit({ url: '/ops/mimics', queryParams: { id: mimic.id } });
    }

    isActiveLink(link: string) {
        return this.router.url.includes(link);
    }
}
